<template>
    <div class="driver-component">
       <!-- 流通商信息 -->
      <div class="main-container-form">
        <section class="head-title clearfix">
          <div class="titleForm-container">流通商信息</div>
          <div class="add" v-if="canEdit" @click="add('circulator')">
            <img src="../../../assets/images/qualityTracing/nav_add.png" alt="">
            <span>添加</span>
          </div>
        </section>
        <div class="formscirculator">
          <el-form :id="'dealer'+index" v-for="(item,index) in dealers" :key="index" :model="item" :rules="rules" ref="item" label-width="100px" >
            <span v-if="canEdit" @click="del('circulator',index)" class="delete">删除</span>
            <el-form-item label="公司名称" prop="name">
              <el-select v-model="item.name" placeholder="请选择" size="medium" style="width:100%;" @change="changeDealer($event,index)">
                <el-option v-for="list in dealerKeyValue" :key="list.id" :label="list.value" :value="list.key" >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="负责人">
              <el-input v-model="item.leader" :disabled="true" size="medium" style="width:100%;" placeholder="请输入真实姓名" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
              </el-input>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="item.phone" :disabled="true" size="medium" style="width:100%;" placeholder="请输入联系电话" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
              </el-input>
            </el-form-item>
            <el-form-item label="地址">
              <el-input v-model="item.address" :disabled="true" size="medium" style="width:100%;" placeholder="请输入详细地址" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
              </el-input>
            </el-form-item>
            <el-form-item label="相关图片" prop="images" v-if="item.images.length!=0">
              <div class="imgList" >
                <img v-for="(img,index) in item.images" :key="index" :src="uploadURl+'/'+img" alt="">
              </div>
            </el-form-item>
            <el-form-item label="营业范围">
              <el-input
                type="textarea"
                autosize
                :disabled="true"
                placeholder="请输入内容"
                v-model="item.scope">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import imgUpload from "../../../service/base-url";
export default {
  name: "DealerComponent",
  props: {
    dealers: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      num20: 20,
      num11: 11,
      num30: 30,
      dealerKeyValue: [], //流通商下拉框列表
      baseForm: {
        name: "",
        leaderId: "", // 联系人
        phone: "",
        detail: "", // 详细地址
        images: [], //图片
        fullAddress: ""
      },
      uploadURl: imgUpload.imgUpload, // 文件上传地址
      rules: {
        name: [
          {
            required: true,
            message: "请先选择公司名称",
            trigger: "change"
          }
        ]
      }
    };
  },
  mounted() {
    this.getCirculationData();
  },
  methods: {
    ...mapActions(modules.circulationBusiness, [
      "getDealerKeyValue", //流通商下拉框列表
      "getSingleCirculationB"
    ]),
    // 展示 图片和附件
    distribution(arr) {
      this.fileList = [];
      arr.forEach(ele => {
        this.fileList.push({
          name: ele.title,
          id: ele.name,
          url: this.uploadURl + "/" + ele.name
        });
        this.baseForm.images.push(ele.name);
      });
    },
    //获取数据
    changeDealer(e, index) {
      this.getSingleCirculationB(e).then(data => {
        this.distribution(data.images);
        this.$emit("getDealer", data, index);
      });
    },
    // 获取流通商keyValue
    getCirculationData() {
      this.getDealerKeyValue()
        .then(rsp => {
          this.dealerKeyValue = rsp;
        })
        .catch(err => {
          console.dir(err);
        });
    },
    // 添加流通商信息
    add(name, item) {
      this.$emit("addDealer");
    },
    // 删除 流通商信息
    del(name, index) {
      this.dealers.splice(index, 1);
    }
  }
};
</script>

<style lang="stylus">


.upload-tip
    position absolute
    top:150px;
    bottom:20px;
    height:30px;
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    font-weight:400;
    color:rgba(176,176,176,1);
.driver-component
  .el-upload
    display none 
  .el-upload-list__item-status-label,.el-icon-close-tip
    display none !important
  .el-upload-list--picture-card .el-upload-list__item-actions,
  .el-upload-list--picture-card .el-upload-list__item-actions:hover 
    display none ;
  textarea
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    font-weight:400;
    color:rgba(51,51,51,1);
    min-height:180px !important;
    width: 500px !important
  .two-row
    display flex;
    .el-form-item
      width:300px;
  .content-form-container
    background :#f2f3f6;
  .el-form-item 
    width:600px;
  .el-input--medium .el-input__inner
    line-height :44px;
    height:44px;
</style>
<style lang="stylus" scoped>
  .formscirculator .el-form{
    border-top:1px solid #eee!important;
  }

  .imgList
    width :800px;
    img 
      width :160px;
      height:148px;
      height :-moz-background-inline-policy 146px;
      margin-right:20px;
      border-radius:5px;

  .main-container-form
    overflow:hidden;
    margin-bottom:10px;
    border:1px solid #e0e0e0;
    background #fff
  .el-form
    position relative
    padding: 28px 0 40px 150px
  .head-title
    line-height:48px;
    font-size:16px;
    background :#f7f7f7;
    .titleForm-container
      float :left;
      height:48px;
      line-height:48px;
      font-weight: initial;
    .add
      float: right;
      margin-right:95px;
      color:#3389FF;
      cursor:pointer;
      img 
        margin-right:7px;
        vertical-align: middle;
      span 
        vertical-align: middle;
  .delete
    position :absolute;
    right: 85px;
    top:28px;
    width:80px;
    border-radius:4px;
    line-height:36px;
    text-align:center;
    color:#fefefe;
    cursor:pointer;
    background:#E23A0D;
  .save-cancel
    padding:20px 0 40px 0;
</style>
